// extracted by mini-css-extract-plugin
export default {"container":"WhyRatezip_container__p-QcD"};